// ============================================
// Sector Interceptor - BinnaclePro
// Agrega el header X-Sector-Id a todas las peticiones
// Similar a AWS que agrega la región a las requests
// ============================================

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SectorStore } from '../stores/sector.store';

/**
 * Interceptor que agrega el sector seleccionado a cada petición HTTP
 *
 * El backend puede usar este header para:
 * - Filtrar datos por sector
 * - Aplicar permisos específicos del sector
 * - Logging y auditoría
 *
 * Si el sector es 0 (Global), no se envía el header
 * y el backend devuelve datos de todos los sectores.
 */
export const sectorInterceptor: HttpInterceptorFn = (req, next) => {
  const sectorStore = inject(SectorStore);

  // URLs que no necesitan el header de sector
  const excludedUrls = ['/auth/', '/sectors'];
  const isExcluded = excludedUrls.some(url => req.url.includes(url));

  if (isExcluded) {
    return next(req);
  }

  const sectorId = sectorStore.selectedSectorId();

  // Solo agregar header si no es modo global (id = 0)
  if (sectorId !== 0) {
    req = req.clone({
      setHeaders: {
        'X-Sector-Id': sectorId.toString()
      }
    });
  }

  return next(req);
};
